import { render } from "./HomeView.vue?vue&type=template&id=46944332&scoped=true"
const script = {}

import "./HomeView.vue?vue&type=style&index=0&id=46944332&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46944332"]])

export default __exports__